import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import modal from './modal/slice';
import appConfig from './app-config/reducer';
import profile from './profile/slice';

const rootReducer = (history: any): any =>
    combineReducers({
        router: connectRouter(history),
        appConfig,
        modal,
        profile
  });

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
